import { render } from "./tag_row.vue?vue&type=template&id=7aa413ca&lang=pug"
import script from "./tag_row.vue?vue&type=script&lang=js"
export * from "./tag_row.vue?vue&type=script&lang=js"

import "./tag_row.vue?vue&type=style&index=0&id=7aa413ca&lang=scss"

import exportComponent from "../../../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__